import { AutocompleteForm } from "modules/common/components/AutocompleteForm";
import type { SbEditableComponentProps } from "types/storyblok";
import type { HeroFormProps } from "./HeroForm.d";
import { InfoCheckmarks } from "./InfoCheckmarks/InfoCheckmarks";
import { Uploader } from "./Uploader/Uploader";

export const HeroForm = ({
  ctaVariant = "primary",
  buttonText = undefined,
  checkmarks = [],
  hideCheckmarks = false,
  sbEditable,
}: SbEditableComponentProps<HeroFormProps>) => (
  <>
    <AutocompleteForm ctaVariant={ctaVariant} buttonText={buttonText} sbEditable={sbEditable} />
    <Uploader />
    {hideCheckmarks || <InfoCheckmarks checkmarks={checkmarks} />}
  </>
);
